import { SummaryHeaderRow } from '../SummaryHeaderRow.js';
import { SummaryTable } from '../SummaryTable.js';
import { SummaryTableBoldDivider } from '../SummaryTableBoldDivider.tsx';
import { SummaryTableRowFromAdjustmentType } from '../SummaryTableRowFromAdjustmentType.tsx';
import { SummaryTableRowFromResultProperty } from '../SummaryTableRowFromResultProperty.tsx';
import { SummaryTitleRow } from '../SummaryTitleRow.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { wholeDollar } from '../utils/formatters/wholeDollar.ts';

export const AdjustmentBreakdownImprovementValueTable = ({
  sequence,
  tableIdx,
  ...props
}: Tkv2PairedCostSummaryInterfaceV2 & {
  sequence: string[];
  tableIdx: number;
}) => {
  return (
    <SummaryTable key={`breakdown-table-${tableIdx}`}>
      <SummaryTitleRow summary={props} sequence={sequence} tableIdx={tableIdx} />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="Improvement Value"
        path="totals.improvements.depreciated.cost"
        formatter={wholeDollar}
        isFirstRow={true}
      />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="Value difference"
        path="totals.improvements.depreciated.netAdjustment"
        formatter={wholeDollar}
        isHiddenForSubject
      />
      <SummaryHeaderRow
        sequence={sequence}
        suppressTopBorder={true}
        firstColumnHeader="Breakdown"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="mainDwelling"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="quality"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="condition"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="functionalUtility"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="garageCarport"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="porchPatioDeck"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="pool"
      />
      <SummaryTableRowFromAdjustmentType section={props} sequence={sequence} adjustmentType="adu" />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="shed"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="workshop"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="bonusRoom"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="attic"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="basement"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="belowGradeANSI"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="barn"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="manufactured"
      />
      <SummaryTableRowFromAdjustmentType
        section={props}
        sequence={sequence}
        adjustmentType="manual"
      />
      <SummaryTableBoldDivider />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="Net Improvement Adj."
        path="totals.improvements.depreciated.netAdjustment"
        typeVariant="h5"
        formatter={adjustment}
        isHiddenForSubject
      />
    </SummaryTable>
  );
};
